module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Walk in “WILD” Wales"), _c('br'), _vm._v(" with George Borrow")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#wild-wales"
    }
  }, [_vm._v("Wild Wales")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#wales-today"
    }
  }, [_vm._v("Wales Today")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#setting-out"
    }
  }, [_vm._v("Setting Out")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#llangollen-to-llanarmon"
    }
  }, [_vm._v("Llangollen to Llanarmon")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#llanarmon-to-llanrhaeadr--ym-mochnant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llanarmon to Llanrhaeadr- Ym-Mochnant")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#llanrhaeadr-ym-mochnant-to-sycharth-castle-and-llansilin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llanrhaeadr-Ym-Mochnant to Sycharth Castle and Llansilin")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#llanrhaeadr-ym-mochnant-to-the-pistyll-rhaeadr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llanrhaeadr-Ym-Mochnant to The Pistyll Rhaeadr")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#pistyll-rhaeadr-to-bala",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pistyll Rhaeadr to Bala")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#bala-to-llanuwchllyn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bala to Llanuwchllyn")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#llanuwchllyn-to-dinas-mawddwy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llanuwchllyn to Dinas Mawddwy")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#dinas-mawddwy-to-mallwyd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dinas Mawddwy to Mallwyd")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#mallwyd-to-machynlleth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mallwyd to Machynlleth")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#machynlleth-to-ponterwyd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Machynlleth to Ponterwyd")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#ponterwyd-to-the-devils-bridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ponterwyd to the Devil’s Bridge")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#devils-bridge-to-ysbyty-ystwyth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil’s Bridge to Ysbyty Ystwyth")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#ysbyty-ystwyth-to-strata-florida",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ysbyty Ystwyth to Strata Florida")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#strata-florida-to-tregaron",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strata Florida to Tregaron")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#tregaron-to-lampeter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tregaron to Lampeter")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#lampeter-to-llandovery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lampeter to Llandovery")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#llandovery-to-llandeilo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llandovery to Llandeilo")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#llandeilo-to-capel-gwynfe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Llandeilo to Capel-Gwynfe")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#capel-gwynfe-to-brynamman-gutter-vawr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Capel-Gwynfe to Brynamman (Gutter Vawr)")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#brynamman-to-pontardawe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brynamman to Pontardawe")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#pontardawe-to-swansea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pontardawe to Swansea")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#on-reflection",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Reflection")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0